import {
  colors,
  typography,
  spacing,
  shadows,
  breakpoints,
  animations,
  radii,
} from "./theme";

// Dark mode color palette
export const darkColors = {
  primary: {
    ...colors.primary,
    // Adjust primary colors for dark mode if needed
  },
  neutral: {
    50: "#1A1E2E",
    100: "#1E2235",
    200: "#252A3F",
    300: "#2D3348",
    400: "#4A5169",
    500: "#6B7280",
    600: "#9CA3AF",
    700: "#D1D5DB",
    800: "#E5E7EB",
    900: "#F3F4F6",
  },
  success: {
    50: "#022C22",
    500: "#22C55E",
    700: "#15803D",
  },
  warning: {
    50: "#422006",
    500: "#F59E0B",
    700: "#B45309",
  },
  error: {
    50: "#450A0A",
    500: "#EF4444",
    700: "#B91C1C",
  },
};

// Semantic colors for dark mode
export const darkSemanticColors = {
  error: {
    ...darkColors.error,
    main: darkColors.error[500],
    dark: darkColors.error[700],
    light: darkColors.error[50],
  },
  success: {
    ...darkColors.success,
    main: darkColors.success[500],
    dark: darkColors.success[700],
    light: darkColors.success[50],
  },
  warning: {
    ...darkColors.warning,
    main: darkColors.warning[500],
    dark: darkColors.warning[700],
    light: darkColors.warning[50],
  },
  primary: {
    ...darkColors.primary,
    main: colors.primary[700],
    hover: colors.primary[800],
    light: colors.primary[100],
    contrastText: "#fff",
    surface: colors.primary[900],
  },
  accent: {
    main: colors.primary[700],
    hover: colors.primary[800],
    surface: colors.primary[900],
    contrastText: "#fff",
  },
  neutral: {
    ...darkColors.neutral,
  },
  surface: {
    default: "#181C27",
    raised: "#23273A",
    paper: "#23273A",
  },
};

export const darkTheme = {
  colors: darkSemanticColors,
  typography,
  spacing,
  shadows,
  radii,
  breakpoints,
  animations,
};

export default darkTheme;
